export default __webpack_public_path__ + "static/media/popcorn.860be52d.png";